import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from 'react';
import { Asset, AssetTable } from "../../Asset.tsx";
import Modal from "../../Modal.tsx";
import Axios from "../../../Axios.js";

const ModalTypeAction = ({ isOpen, onClose, data, toggle }) => {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});

  const [name, setName] = useState("");
  const [id, setId] = useState(null);
  const [base64Icon, setBase64Icon] = useState("");

  useEffect(() => {
    setErrors({});
    if (data != null && data) {
      setName(data.name);
      setId(data.id_type_action);
      setBase64Icon(data.icon);
      console.log(data)
    }
    else {
      setName('');
      setId(null);
      setBase64Icon('');
    }
  }, [data, isOpen]);


  const validateForm = () => {
    const newErrors: { name: string } = {};

    //REGEX POUR NAME INTERDIRE , ET /
    let regex = new RegExp(/^[^,\/]+$/);

    if (name === "" || name == null || name.length < 3) {
      newErrors.name = t("action type name too short");
    }
    else if (name.length > 255) {
      newErrors.name = t("action type name too long");
    }
    else if (!regex.test(name)) {
      newErrors.name = t("action type name contains invalid characters (, or /)");
    }

    if (base64Icon === "" || base64Icon == null) {
      newErrors.icon = t("icon required");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64Icon(reader.result.replace('data:image/svg+xml;base64,', ''));
    };
    reader.readAsDataURL(file);
  };


  const updateTypeAction = async (data) => {
    console.log("update action type");

    if (data && Object.keys(data).length > 0) {

      if (data) {
        try {
          const config = {
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem('token')
            },
            withCredentials: true
          };

          const response = (data.id == null) ?
            await Axios.post(`api/fp/type_actions/`, data, config) :
            await Axios.put(`api/fp/type_actions/?id=${data.id}`, data, config);

          if (response.status === 200) {
            console.log("location updated")
            return;
          }
          console.log(response);
        }

        catch (error) {
          console.error("Error during modify task:", error);
        }
      }
    }
  }


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      toggle();

      let json = {
        name: name,
        id: id,
        icon: base64Icon,
      };

      console.log(json);
      updateTypeAction(json)
      onClose(json, 'action type');
    }
  };


  if (!isOpen) return null;

  let form = (
    <form className="p-4" onSubmit={handleSubmit}>
      <div className="grid gap-4 mb-4 grid-cols-2">
        <div className="mb-2 col-span-2">
          <label htmlFor="category" className="modal-label"> {t('Mission type')} </label>
          <input
            id="name"
            className="modal-input"
            required
            value={name}
            placeholder={t('name')}
            onChange={(e) => { setName(e.target.value) }}
          />
          {errors.name && <p className="text-red-500">{errors.name}</p>}
        </div>
      </div>


      <div className="grid gap-4 mb-4 grid-cols-2">
        <div>
          <label className="modal-label"> {t('Icon propositions')} </label>
          <Asset
            asset={AssetTable.iconAsset}
            onClick={item => { setBase64Icon(item.icon) }}
            iconOnly={true}
          />
        </div>
        <div>
          <label htmlFor="upload-icon" className="modal-label"> {t('Selected icon')} </label>
          <label htmlFor="upload-icon" className="modal-input select-none relative" style={{ color: "#9090AA" }}> {
            base64Icon ? (
              <>
                <img
                  className="w-16 h-16 place-self-center"
                  src={`data:image/svg+xml;base64,${base64Icon}`}
                  alt=""
                />
                <div className="absolute w-7 h-7 bg-gray-200 hover:bg-gray-300 right-1 bottom-1 rounded">
                  <svg className="w-7 h-7 p-px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 4H8.8C7.11984 4 6.27976 4 5.63803 4.32698C5.07354 4.6146 4.6146 5.07354 4.32698 5.63803C4 6.27976 4 7.11984 4 8.8V15.2C4 16.8802 4 17.7202 4.32698 18.362C4.6146 18.9265 5.07354 19.3854 5.63803 19.673C6.27976 20 7.11984 20 8.8 20H15.2C16.8802 20 17.7202 20 18.362 19.673C18.9265 19.3854 19.3854 18.9265 19.673 18.362C20 17.7202 20 16.8802 20 15.2V11" stroke="#777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M4 16L8.29289 11.7071C8.68342 11.3166 9.31658 11.3166 9.70711 11.7071L13 15M13 15L15.7929 12.2071C16.1834 11.8166 16.8166 11.8166 17.2071 12.2071L20 15M13 15L15.25 17.25" stroke="#777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M18 8V3M18 3L16 5M18 3L20 5" stroke="#777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </div>
              </>
            ) : t('Choose file (.svg)')
          }</label>
          {errors.icon && <p className="text-red-500">{errors.icon}</p>}

          <input
            type="file"
            accept=".svg"
            id="upload-icon"
            placeholder={t('icon (.svg)')}
            className="opacity-0 -z-1 absolute"
            onChange={handleFileChange}
          />
        </div>

      </div>

      <div className="flex justify-end">
        <button
          type="submit"
          className="form-button-validate"
        >
          {t("validate")}
        </button>
      </div>
    </form>
  );

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      title={t('Mission Type')}
      form={form}
      width={55}
    />
  );
}

export default ModalTypeAction;
